// const baseUrl = 'https://windbug-api-dev.sirpi.co.in/'
// const baseUrl = "/heroku/";

// On localhost, the auth cookie can never be sent cross-domain to the real
// backend (sirpi.co.in), so requests are routed through the same-origin
// proxy in src/setupProxy.js instead, which forwards them server-side.
const baseUrl =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "/api/"
    : process.env.REACT_APP_API_URL;

const isMaintainence = false;
const envUrls = {
  baseUrl,
  isMaintainence,
};

export default envUrls;
